import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

/**
 * Contenitore standard per le pagine dell'area account (larghezza piena del main).
 */
const AccountPageShell = ({
  children,
  title,
  titleId,
  subtitle,
  titleAlign = 'left',
  pb,
}) => (
  <Box
    bg="#2f3136"
    p={{ base: 6, md: 8 }}
    borderRadius="20px"
    boxShadow="0 20px 40px rgba(0, 0, 0, 0.3)"
    border="1px solid"
    borderColor="gray.600"
    w="full"
    pb={pb}
  >
    {title && (
      <Heading
        size="lg"
        id={titleId}
        color="white"
        fontWeight="800"
        textAlign={titleAlign}
        mb={subtitle ? 2 : 6}
      >
        {title}
      </Heading>
    )}
    {subtitle && (
      <Text color="gray.300" fontSize="sm" textAlign={titleAlign} mb={6}>
        {subtitle}
      </Text>
    )}
    {children}
  </Box>
);

export default AccountPageShell;
